import SidebarLayout from "components/Layout/Layout";
import { useEffect, useState } from "react";
import { FeatureType, SubscriptionType } from "./type";
import getListSupcriptions from "./function/getAllSubcription";
import getAllFeatures from "./function/getAllFeature";
import { Button, Input, Modal, Space } from "antd";
import AddFeaturesModal from "./component/addFeatureModal";
import AddModalSubscriptions from "./component/addSubcriptionsModal";
import SubscriptionDisplayItem from "./component/subcriptionsItem";
import FeatureItems from "./component/featureItems";

const Subscriptions = () => {
    const [subcriptions, setSubscriptions] = useState<SubscriptionType[]>([]);
    const [allFeature, setAllFeature] = useState<FeatureType[]>([]);
    const [filteredFeatures, setFilteredFeatures] = useState<FeatureType[]>([]);
    const [openAddFeature, setOpenAddFeature] = useState(false);
    const [openAddSubscription, setOpenAddSubscription] = useState(false);
    const [activeTab, setActiveTab] = useState<"subscriptions" | "features">("subscriptions");
    const [triggerReload, setTriggerReload] = useState(0);

    const [searchName, setSearchName] = useState("");
    const [searchKey, setSearchKey] = useState("");
    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        getListSupcriptions(0, 0, 0).then(setSubscriptions).catch(console.error);
        getAllFeatures(0, 0).then(res => {
            setAllFeature(res);
            setFilteredFeatures(res);
        }).catch(console.error);
    }, [triggerReload]);

    const applyFilters = () => {
        setFilteredFeatures(
            allFeature.filter(f =>
                f.name.toLowerCase().includes(searchName.toLowerCase()) &&
                (f.key ? f.key.toLowerCase().includes(searchKey.toLowerCase()) : searchKey === "") &&
                (f.number != null ? f.number.toString().includes(searchValue) : searchValue === "")
            )
        );
    };

    const clearFilters = () => {
        setSearchName("");
        setSearchKey("");
        setSearchValue("");
        setFilteredFeatures(allFeature);
    };

    return (
        <SidebarLayout>
            <div className="space-y-4">
                {/* Tab bar + action button */}
                <div className="flex items-center justify-between">
                    <div className="flex gap-1">
                        {(["subscriptions", "features"] as const).map(tab => (
                            <button
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors capitalize ${
                                    activeTab === tab
                                        ? "bg-blue-600 text-white"
                                        : "text-text-secondary hover:bg-bg-hover"
                                }`}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                    <Button
                        type="primary"
                        onClick={() => activeTab === "features" ? setOpenAddFeature(true) : setOpenAddSubscription(true)}
                    >
                        + Add {activeTab === "subscriptions" ? "Subscription" : "Feature"}
                    </Button>
                </div>

                {/* Content */}
                {activeTab === "subscriptions" ? (
                    <div className="grid grid-cols-1 gap-4">
                        {subcriptions.length === 0
                            ? <p className="text-text-muted">No subscriptions available.</p>
                            : subcriptions.map(s => (
                                <SubscriptionDisplayItem
                                    key={s.id}
                                    subscription={s}
                                    setTriggerReload={setTriggerReload}
                                />
                            ))
                        }
                    </div>
                ) : (
                    <div className="space-y-4">
                        <Space wrap>
                            <Input
                                placeholder="Search by Name"
                                value={searchName}
                                onChange={e => setSearchName(e.target.value)}
                                className="w-48"
                            />
                            <Input
                                placeholder="Search by Key"
                                value={searchKey}
                                onChange={e => setSearchKey(e.target.value)}
                                className="w-48"
                            />
                            <Input
                                placeholder="Search by Value"
                                value={searchValue}
                                onChange={e => setSearchValue(e.target.value)}
                                className="w-48"
                            />
                            <Button type="primary" onClick={applyFilters}>Apply</Button>
                            <Button onClick={clearFilters}>Clear</Button>
                        </Space>

                        <div className="grid grid-cols-2 gap-4">
                            {filteredFeatures.map(f => (
                                <FeatureItems key={f.id} feature={f} setTriggerReload={setTriggerReload} />
                            ))}
                        </div>
                    </div>
                )}
            </div>

            <Modal
                title="Add New Subscription"
                open={openAddSubscription}
                width={800}
                onCancel={() => setOpenAddSubscription(false)}
                footer={null}
            >
                <AddModalSubscriptions
                    setTriggerReload={setTriggerReload}
                    onClose={() => setOpenAddSubscription(false)}
                />
            </Modal>

            <Modal
                title="Add New Feature"
                open={openAddFeature}
                onCancel={() => setOpenAddFeature(false)}
                footer={null}
            >
                <AddFeaturesModal onClose={() => setOpenAddFeature(false)} />
            </Modal>
        </SidebarLayout>
    );
};

export default Subscriptions;
